import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AdminTrustScores = lazy(() => import("@/pages/admin/AdminTrustScores"));

export const Route = createFileRoute("/admin/trust-scores")({
  component: AdminTrustScores,
});
